import React, { useState } from "react";
import logo from "../assets/logo/Logo.svg";
import google from "../assets/logo/Google.svg";
import facebook from "../assets/logo/Facebook.svg";
import apple from "../assets/logo/apple.png";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "../components/carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const OTP_EXPIRY_SECONDS = 5 * 60;
export default function ForgotPassword() {
  const [formData, setFormData] = useState({

    mobile: "",
    countryCode: "+91", // Default country code
  });
  const [selectedMethod, setSelectedMethod] = useState("email"); // Default: email
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [countryCode, setCountryCode] = useState("+91"); // Default country code
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
const [isSubmitting, setIsSubmitting] = useState(false);

  const API_URL = `${API_BASE_URL}/auth`;


  // ✅ Country options for phone input
  // const countryOptions = [
  //   { label: "🇮🇳 India (+91)", value: "+91" },
  //   { label: "🇺🇸 USA (+1)", value: "+1" },
  //   { label: "🇬🇧 UK (+44)", value: "+44" },
  //   { label: "🇦🇺 Australia (+61)", value: "+61" },
  // ];
  const countryOptions = [
    { code: "US", name: "United States", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/us.png" },
    { code: "GB", name: "United Kingdom", dialCode: "+44", flagUrl: "https://flagcdn.com/w40/gb.png" },
    { code: "CA", name: "Canada", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/ca.png" },
    { code: "AU", name: "Australia", dialCode: "+61", flagUrl: "https://flagcdn.com/w40/au.png" },
    { code: "DE", name: "Germany", dialCode: "+49", flagUrl: "https://flagcdn.com/w40/de.png" },
    { code: "FR", name: "France", dialCode: "+33", flagUrl: "https://flagcdn.com/w40/fr.png" },
    { code: "JP", name: "Japan", dialCode: "+81", flagUrl: "https://flagcdn.com/w40/jp.png" },
    { code: "CN", name: "China", dialCode: "+86", flagUrl: "https://flagcdn.com/w40/cn.png" },
    { code: "IN", name: "India", dialCode: "+91", flagUrl: "https://flagcdn.com/w40/in.png" },
    { code: "BR", name: "Brazil", dialCode: "+55", flagUrl: "https://flagcdn.com/w40/br.png" },
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "56px",
      borderRadius: "20px",
      border: "0.5px solid #095228",
      padding: "5px",
    }),
    control: (base) => ({
      ...base,
      minWidth: 100,
      minHeight: "100%",
      borderRadius: "12px",
      border: "0.5px solid #095228",
      padding: "10px 5px",
    }),
    option: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures it appears on top
  };
  // // ✅ Handle country change
  // const handleCountryChange = (selectedOption) => {
  //   setCountryCode(selectedOption.value);
  // };
  const handleCountryChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      countryCode: selectedOption.dialCode, // Update the country code
    }));
  };
  // ✅ Handle Google Login
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/google`;
  };

  // ✅ Handle Facebook Login
  const handleFacebookLogin = () => {
    window.location.href = `${API_URL}/facebook`;
  };

  // ✅ Handle Form Submission with API Response Validation
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError(null); // Clear previous errors

  //   if (!email.trim()) {
  //     setError("Please enter your email or phone number.");
  //     return;
  //   }

  //   try {
  //     let requestData = {};

  //     if (selectedMethod === "email") {
  //       requestData = { email }; // ✅ Normal case: Send actual email
  //     } else if (selectedMethod === "phone") {
  //       requestData = { email: `${countryCode}-${email}` }; // ✅ Send mobile number under "email" key
  //     }

  //     const response = await fetch(`${API_URL}/forget-password`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(requestData),
  //     });

  //     const data = await response.json();
  //     console.log("Backend Response:", data);

  //     if (!response.ok || !data.success) {
  //       setError(data.message || "Invalid email or phone number.");
  //       return;
  //     }

  //     // ✅ Store email (or mobile number) in sessionStorage
  //     sessionStorage.setItem("userEmail", requestData.email);
  //     console.log("Email stored in sessionStorage:", requestData.email);

  //     // ✅ Store reset token if provided
  //     if (data.result?.data) {
  //       sessionStorage.setItem("resetToken", data.result.data);
  //       console.log("Token stored in sessionStorage:", data.result.data);
  //     } else {
  //       console.warn("No token received from backend.");
  //     }

  //     // ✅ Redirect based on selection
  //     if (selectedMethod === "email") {
  //       navigate(`/verifycode?email=${encodeURIComponent(requestData.email)}`);
  //     } else {
  //       navigate(`/verifycodemobile?mobile=${encodeURIComponent(requestData.email)}`);
  //     }
  //   } catch (err) {
  //     setError("Something went wrong. Please try again.");
  //     console.error("Error:", err);
  //   }
  // };


  // ✅ Handle Form Submission with API Response Validation
  const handleSubmit = async (e) => {
    e.preventDefault();
 // 🚫 BLOCK multiple clicks
  if (isSubmitting) return;

  setIsSubmitting(true);
  setError(null);
    let requestData = {};
    if (selectedMethod === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email.trim()) {
        setError("Please enter your email.");
              setIsSubmitting(false);

        return;
      }
      if (!emailRegex.test(email.trim())) {
        setError("Please enter a valid email address.");
        setIsSubmitting(false);
        return;
      }
      requestData = { email };
    } else if (selectedMethod === "phone") {
      if (!mobile.trim()) {
        setError("Please enter your Mobile number.");
              setIsSubmitting(false);

        return;
      }
      requestData = { email: `${countryCode}-${mobile}` }; // ✅ API requires mobile as "email"
    }

    try {
      const response = await fetch(`${API_URL}/forget-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      console.log("Backend Response:", data);

      if (!response.ok || !data.success) {
        // ✅ Check the API response message and show appropriate errors
        if (data.message === "Credentials not found") {
          setError(
            selectedMethod === "email"
              ? "Email does not exist."
              : "Please enter registered Mobile number."
          );
        }  setIsSubmitting(false);
      return;
    }

      // ✅ Store email or mobile number
      sessionStorage.setItem("userEmail", requestData.email);
      localStorage.setItem("userEmail", requestData.email);
      console.log("Stored in session:", requestData.email);

      // ✅ Store reset token if provided
      if (data.result?.data) {
        sessionStorage.setItem("resetToken", data.result.data);
        localStorage.setItem("resetToken", data.result.data);
        console.log("Reset Token stored:", data.result.data);
      }
      sessionStorage.setItem(
        "resendOtpExpiresAt",
        String(Date.now() + OTP_EXPIRY_SECONDS * 1000)
      );

      // ✅ Redirect based on selection
      if (selectedMethod === "email") {
        navigate(`/verifycode?email=${encodeURIComponent(requestData.email)}`);
      } else {
        navigate(`/verifycodemobile?mobile=${encodeURIComponent(requestData.email)}`);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
      } finally {
    // ✅ ALWAYS reset loading
    setIsSubmitting(false);
  }
};

  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left side image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3">
            <Carousel slides={[loginbanner, loginbannertwo, loginbannerthree, loginbannerfour]} />
            <img src={bannerlayout} alt="Overlay" className="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>

        {/* Right side login form */}
        <div className="w-full lg:w-1/2 login-content flex flex-col">
          <div className="login-form">
            <div className="frg-pass flex flex-col items-center justify-center px-6">
              {/* Logo */}
              <div className="logo">
                <img src={logo} alt="Pipaan Logo" width={150} height={50} />
              </div>

              {/* Back to login */}
              <div className="w-full max-w-md">
                <div className="text-[#313131] text-sm flex items-center mb-4 font-medium">
                  <Link to="/login">
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"></path>
                    </svg>
                  </Link>
                  <Link to="/login">
                    Back to login</Link>
                </div>


                {/* Forgot Password Form */}
                <h1 className="text-2xl font-semibold text-center mb-4">Forgot Your Password?</h1>

                <form onSubmit={handleSubmit} className="space-y-4 frg-pass-content">
                  {/* Radio Buttons for Selection */}
                  <div className="flex justify-center space-x-4 mb-4">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="recoveryMethod"
                        value="email"
                        checked={selectedMethod === "email"}
                        onChange={() => setSelectedMethod("email")}
                        className="w-4 h-4 border-[#095228] rounded-full focus:ring-green-500"
                      />
                      <span className="text-sm text-[#344054]">Email</span>
                    </label>

                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="recoveryMethod"
                        value="phone"
                        checked={selectedMethod === "phone"}
                        onChange={() => setSelectedMethod("phone")}
                        className="w-4 h-4"
                      />
                      <span className="text-sm text-[#344054]">Phone No</span>
                    </label>
                  </div>

                  {/* Email or Phone Input */}
                  {selectedMethod === "email" ? (
                    <div className="pb-5">
                      <label className="text-sm font-medium block mb-2">Email</label>
                      <input
                        type="email"
                        placeholder="Enter your Email ID"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-3 py-4 border border-gray-300 rounded-[12px] focus:ring focus:ring-blue-200 outline-none"
                        required
                      />
                    </div>
                  ) : (
                    <div className="forget-password-toggle pb-5">
                      <label className="text-sm font-medium block mb-2">Mobile Number</label>
                      <div className="flex items-center space-x-3">
                        {/* <Select
                          options={countryOptions}
                          value={countryOptions.find((c) => c.value === countryCode)}
                          onChange={handleCountryChange}
                          className="w-28"
                        /> */}
                        <Select
                          options={countryOptions}
                          getOptionLabel={(e) => (
                            <div className="flex items-center">
                              <img src={e.flagUrl} alt="" className="w-full h-full" />
                              <span className="ml-2 hidden">{e.dialCode}</span>
                            </div>
                          )}
                          getOptionValue={(e) => e.dialCode}
                          value={countryOptions.find((c) => c.dialCode === formData.countryCode)}
                          onChange={handleCountryChange}
                          styles={customStyles}
                          menuPortalTarget={document.body} // Ensures popup behavior
                          menuPosition="absolute"
                        />
                        <input
                          type="tel"
                          placeholder="Mobile Number"
                          value={mobile}
                          onChange={(e) => {
                            const digits = e.target.value.replace(/\D/g, "").slice(0, 15);
                            setMobile(digits);
                          }}
                          onKeyDown={(e) => {
                            // Allow control/navigation keys and shortcuts
                            const allowedKeys = ["Backspace","Delete","Tab","Escape","Enter","ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Home","End"];
                            if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;

                            // Prevent non-digit keys
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                              return;
                            }

                            // Prevent typing more than 15 digits when there's no selection to replace
                            const target = e.target;
                            const selectionLength = (target.selectionEnd || 0) - (target.selectionStart || 0);
                            if ((target.value.replace(/\D/g, "").length - selectionLength) >= 15) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            e.preventDefault();
                            const paste = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "");
                            const target = e.target;
                            const start = target.selectionStart || 0;
                            const end = target.selectionEnd || 0;
                            const pre = mobile.slice(0, start);
                            const post = mobile.slice(end);
                            const combined = (pre + paste + post).replace(/\D/g, "").slice(0, 15);
                            setMobile(combined);
                          }}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength={15}
                          className="w-full px-3 py-4 border border-gray-300 rounded-[12px] focus:ring focus:ring-blue-200 outline-none"
                          required
                        />
                      </div>
                    </div>
                  )}

                  {error && <p className="text-red-500 text-sm">{error}</p>}

                  <button type="submit"   disabled={isSubmitting}
className={`w-full py-3 rounded-xl font-medium text-white
    ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-[#1B2537]"}`}>
                            {isSubmitting ? "Sending OTP..." : "Submit"}

                  </button>
                </form>


                {/* Social Login */}
                <div className="relative mt-12 mb-4">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t-2 border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-white px-2 text-gray-500">Login With</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-10 mx-auto w-fit">
                  <button className="w-full rounded-lg p-2" onClick={handleGoogleLogin}>
                    <img
                      src={google}
                      alt="Facebook"
                      className=" mx-auto" />
                  </button>
                  <button className="w-full rounded-lg p-2" onClick={handleFacebookLogin}>
                    <img
                      src={facebook}
                      alt="Facebook"
                      className=" mx-auto"
                    />
                  </button>
                  {/* <button className="w-full rounded-lg ">
                    <img
                      src={apple}
                      alt="Apple"
                      className=" mx-auto"
                    />
                  </button> */}
                </div>
                {/* Signup Link */}
                <p className="lg:hidden text-center text-sm text-[#122B31] mt-4">
                  Don't you have an account?{" "}
                  <Link to="/signup" className="text-[#006838] font-semibold hover:underline">
                    Create New Account
                  </Link>
                </p>

                {/* Footer */}
                <div className="lg:hidden">
                  <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                    © 2025 Pipaan. All Rights Reserved
                  </div>
                </div>
              </div>
            </div>

            {/* Signup Link */}
            <p className="text-center text-sm text-[#313957] mt-4">
              Don't have an account?{" "}
              <Link to="/signup" className="text-[#006838] font-semibold hover:underline">
                Create New Account
              </Link>
            </p>

          </div>
        </div>
      </div>
    </div>
  );
}
